export default __webpack_public_path__ + "static/media/M8 - Ocean View.230b6c9e.png";